import { mixinActions, mixinMutations } from '@/store/mixins';
import defaultState from '@/store/modules/egeSubjects/defaultState';
const state = defaultState();
const mutations = {
    ...mixinMutations(),
};
const actions = {
    ...mixinActions(),
    async getEgeSubjectsData({ rootGetters }, { query, params }) {
        return await this.getDataStore(`${rootGetters.API_URL}/ai_ege_subjects`, { ...query, ...params });
    },
    async getEgeQuestionsData({ rootGetters }, { query, params }) {
        return await this.getDataStore(`${rootGetters.API_URL}/ai_ege_question_numbers`, { ...query, ...params });
    },
    async getEgeSubjects({ commit, rootGetters }, url) {
        const response = await this.getDataStore(`${rootGetters.API_URL}${url}`, { all: 1 });
        const { data } = response;
        commit('setProperty', { name: 'egeSubjects', value: data });
    },
    async egeSubjectAction({ rootGetters }, payload) {
        const { action, url, ...data } = payload;
        const response = await this.postDataStore(`${rootGetters.API_URL}${url}/${action}`, data, 'POST');
        return response.data;
    },
    async updateEgeSubject({ rootGetters }, { url, id, title }) {
        return await this.postDataStore(`${rootGetters.API_URL}${url}/${id}`, { title }, 'PUT');
    },
    async getList({ rootGetters }, payload) {
        const { params } = payload;
        return await this.getDataStore(`${rootGetters.API_URL}/ai_ege_subjects`, params);
    },
    async createEgeSubject({ rootGetters }, payload) {
        const { name } = payload;
        const data = { name };
        const isNew = isNaN(Number(payload.id));
        const method = isNew ? 'POST' : 'PUT';
        const url = isNew ? `${rootGetters.API_URL}/ai_ege_subjects` : `${rootGetters.API_URL}/ai_ege_subjects/${payload.id}`;
        return await this.postDataStore(url, data, method);
    },
    async deleteEgeSubject({ rootGetters }, id) {
        return await this.postDataStore(`${rootGetters.API_URL}/ai_ege_subjects/${id}`, {}, 'DELETE');
    },
    async getEgeSubjectById({ rootGetters }, id) {
        const response = await this.getDataStore(`${rootGetters.API_URL}/ai_ege_subjects`, { ids: id });
        const { data } = response;
        return data[0];
    },
    async getEgeQuestionsList({ rootGetters }, payload) {
        const { params } = payload;
        return await this.getDataStore(`${rootGetters.API_URL}/ai_ege_question_numbers`, params);
    },
    async egeQuestionsMultiUpdate({ rootGetters }, payload = []) {
        return await this.postDataStore(`${rootGetters.API_URL}/ai_ege_question_numbers/multi_sort`, payload);
    },
    async egeQuestionAction({ rootGetters }, payload) {
        const { action, url, ...data } = payload;
        const response = await this.postDataStore(`${rootGetters.API_URL}${url}/${action}`, data, 'POST');
        return response.data;
    },
    async updateEgeQuestion({ rootGetters }, { url, id, title }) {
        return await this.postDataStore(`${rootGetters.API_URL}${url}/${id}`, { title }, 'PUT');
    },
    async createEgeQuestion({ rootGetters }, payload) {
        const data = {
            name: payload.name,
            ai_ege_subject_id: payload.ai_ege_subject_id,
            answer_type: payload.answer_type,
            prompt: payload.prompt,
            use_image: payload.use_image,
            use_example: payload.use_example
        } = payload;
        const isNew = isNaN(Number(payload.id));
        const method = isNew ? 'POST' : 'PUT';
        const url = isNew ? `${rootGetters.API_URL}/ai_ege_question_numbers` : `${rootGetters.API_URL}/ai_ege_question_numbers/${payload.id}`;
        return await this.postDataStore(url, data, method);
    },
    async deleteEgeQuestion({ rootGetters }, id) {
        return await this.postDataStore(`${rootGetters.API_URL}/ai_ege_question_numbers/${id}`, {}, 'DELETE');
    },
    async getEgeQuestionById({ rootGetters }, id) {
        const response = await this.getDataStore(`${rootGetters.API_URL}/ai_ege_question_numbers`, { ids: id });
        const { data } = response;
        return data[0];
    },
    async getEgeExamplesList({ rootGetters }, payload) {
        const { params } = payload;
        return await this.getDataStore(`${rootGetters.API_URL}/ai_ege_examples`, params);
    },
    async egeExamplesMultiUpdate({ rootGetters }, payload = []) {
        return await this.postDataStore(`${rootGetters.API_URL}/ai_ege_examples/multi_sort`, payload);
    },
    async egeExampleAction({ rootGetters }, payload) {
        const { action, url, ...data } = payload;
        const response = await this.postDataStore(`${rootGetters.API_URL}${url}/${action}`, data, 'POST');
        return response.data;
    },
    async updateEgeExample({ rootGetters }, { url, id, title }) {
        return await this.postDataStore(`${rootGetters.API_URL}${url}/${id}`, { title }, 'PUT');
    },
    async createEgeExample({ rootGetters }, payload) {
        const data = {
            ai_ege_subject_id: payload.ai_ege_subject_id,
            ai_ege_question_number_id: payload.ai_ege_question_number_id,
            answer_type: payload.answer_type,
            question: payload.question,
            prompt: payload.prompt
        } = payload;
        const isNew = isNaN(Number(payload.id));
        const method = isNew ? 'POST' : 'PUT';
        const url = isNew ? `${rootGetters.API_URL}/ai_ege_examples` : `${rootGetters.API_URL}/ai_ege_examples/${payload.id}`;
        return await this.postDataStore(url, data, method);
    },
    async deleteEgeExample({ rootGetters }, id) {
        return await this.postDataStore(`${rootGetters.API_URL}/ai_ege_examples/${id}`, {}, 'DELETE');
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
